import { EwebinarFragmentForSessions } from '$/shared/frontend/types';
import EDate from '$/shared/frontend/utils/EDate';
import type { EwebinarSessions } from '$/shared/typesProxy';
import { ServerDateNow } from '$/utils/serverDate';
import React from 'react';

import { useEwebinarSessionCalculator } from './useEwebinarSessionCalculator';

export const useEwebinarSession = ({
  ewebinar,
  timezone,
  justInTimeDate,
  justInTimeName,
  serverDateNow,
  skipFromNow,
}: {
  ewebinar: EwebinarFragmentForSessions | null | undefined;
  timezone: string;
  skipFromNow?: boolean;
  justInTimeDate?: EDate;
  justInTimeName?: string;
  serverDateNow?: ServerDateNow;
}): {
  sessions: EwebinarSessions | undefined;
  refresh: () => Promise<void>;
  isLoading: boolean;
} => {
  const [ewebinarSession, setEwebinarSession] = React.useState<EwebinarSessions | undefined>(
    undefined
  );
  const [isLoading, setIsLoading] = React.useState(true);
  const calcEWebinarSessions = useEwebinarSessionCalculator();
  const refresh = React.useCallback(async (): Promise<void> => {
    if (!ewebinar) return;
    const sessions = await calcEWebinarSessions(
      ewebinar,
      timezone,
      skipFromNow,
      justInTimeDate,
      justInTimeName,
      serverDateNow
    );
    setIsLoading(false);
    setEwebinarSession(sessions);
  }, [
    calcEWebinarSessions,
    ewebinar,
    skipFromNow,
    timezone,
    justInTimeDate,
    justInTimeName,
    serverDateNow,
  ]);

  React.useEffect(() => {
    if (ewebinar) refresh();
  }, [ewebinar, refresh]);

  return { sessions: ewebinarSession, refresh, isLoading };
};
